module.exports = __webpack_public_path__ + "img/DIS-Logo-Black.9d8122b5.png";